import { SvgIcon } from '@mui/material';
import { ReactComponent as WalletSVG } from "./wallet-en.svg";

export default function IconIOSWalletEN(props) {
  return <SvgIcon {...props} component={WalletSVG} viewBox="0 0 107 34" />;
}